import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import RoutableSitecoreLink from '../../@shared/routableSitecoreLink';
import { NavigationItemLinkModel } from '../models/navigationItem.model';

const NavigationAccordionLinkItem = (props: { model: NavigationItemLinkModel; closeMainNavigation }) => {
  const { model, closeMainNavigation } = props;
  return (
    <li className="navigation__accordion-item">
      {/* @todo check if this causes problems in EE*/}
      <RoutableSitecoreLink
        className="navigation__accordion-item__trigger navigation__accordion-item__trigger--link"
        field={model.link}
        onClick={closeMainNavigation}
      >
        <RichText field={model.menuTitle} tag="div" className="rich-text" />
      </RoutableSitecoreLink>
    </li>
  );
};

export default NavigationAccordionLinkItem;
